let port = "8000" //9000, 8000
let host = "localhost" //localhost, 10.100.52.165
export const BASENAME = '/frontend'
export const BASE_URL = process.env.REACT_APP_BASE_URL

// Registration
export const VERIFY_TOKEN = "api/v1/user/verify-token"
export const CREATE_ISSUER = "api/v1/issuer/create-issuer"
export const UPDATE_PHONE = "api/v1/issuer/update-phone/"//email_id
export const GET_OTP = "api/v1/user/send-otp"
export const VERIFY_OTP = "api/v1/user/verify-otp"
export const GET_KEYPAIR = "api/v1/issuer/generate-key-pair/"


//VERIFIER REGISTRATION
export const EMAIL_SIGNUP="api/v1/verifier/signup/email"
export const SIGNUP_VERIFER="/api/v1/verifier/signup/register"
export const GSTIN_ADDRESSES="/api/v1/verifier/signup/gstin-addresses/" //{gstin}

// Forgot password
export const FORGOT_PASSWORD = '/api/v1/user/forgot-password/' //email_id
export const SET_PASSWORD = '/api/v1/user/set-password'
// Login
export const USER_LOGIN = "api/v1/user/login"
export const GET_MFA = "api/v1/user/send-mfa"
export const MFA_VERIFY = "api/v1/user/verify-mfa"
export const USER_TOKEN = "api/v1/user/update_access_token/" //email_id
export const ACCEPT_TERMS="/api/v1/user/accept-terms" //user_id
export const MAINTENANCE_STATUS="/api/v1/files/check-maintenance-mode-status"
export const GET_VERIFIER_BANNER="/api/v1/notification/get-verifier-banner/"
export const LOGOUT_USER="api/v1/user/logout"

// dashboard
export const GET_ALL_ISSUERS = "api/v1/issuer/get-all-issuers"
export const GET_DISTINCT_ISSUER = "/api/v1/issuer/get-all-distinct-issuers"
export const GET_ALL_ISSUERS_WITH_STATE = "api/v1/issuer/get-issuer-state-and-count"
export const GET_STATE_COUNT = "/api/v1/issuer/get-user-count"
export const UPDATE_GET_ALL_ISSUERS_WITH_STATE = "/api/v1/issuer/updated-get-issuer-state-and-count"
export const SEND_ONBOARD_EMAIL = 'api/v1/issuer/onboard-issuer-with-email'
export const UPDATE_PASSWORD = "api/v1/user/update-password/" //{user_id}
export const UPDATE_ISSUER = "api/v1/issuer/update-issuer"
export const GET_ALL_DOCS_ISSUER_ID = "api/v1/issuer/get-all-document-by-issuer-id/"//{issuer_id}
export const GET_ALL_COMPLETED_DOCS_ISSUER_ID = "api/v1/issuer/get-completed-document-by-issuer-id/"//{issuer_id}
export const GET_DOCS_ISSUER_ID = "api/v1/issuer/get-document-by-issuer-id/"//{issuer_id}
export const MARK_DROP = "api/v1/issuer/mark-issuer-dropped/"//email_id
export const ACTIVATE = "api/v1/issuer/reactivate-issuer/"//email_id
export const DASHBOARD_DATA = "api/v1/issuer/issuer-dashboard/"//issuer id
export const GET_ISSUER = 'api/v1/issuer/get-issuer-by-id/'

//verifier Onboarding
export const SEND_ONBOARD_EMAIL_VERIFIER = '/api/v1/verifier/onboard-verifier-with-email'
export const REGISTER_VERIFIER = 'api/v1/verifier/register-verifier'
export const GET_VERIFIER_DEFAULT_FIELDS_FOR_DOCS = '/api/v1/verifier/get-default-fields-for-documents'
export const GET_VERIFIER_FORMS = '/api/v1/verifier/get-verifier-forms-verifier-id/' //  verifier id
export const CREATE_FORM = '/api/v1/verifier/create-form'
export const GET_VERIFIER = '/api/v1/verifier/get-verifier-details-by-verifier-id/' //  verifier id
export const UPDATE_VERIFIER = '/api/v1/verifier/update-verifier' //  verifier id
export const UPDATE_VERIFIER_FORM = '/api/v1/verifier/update-verifier-forms-by-doc-field-uuid/'
export const VERIFIER_DROP = '/api/v1/verifier/mark-verifier-dropped/' //{verifier_email}
export const VERIFIER_ACTIVE = '/api/v1/verifier/reactivate-verifier/' //{verifier_email}
export const GET_VERIFIER_FORM_DASH = '/api/v1/verifier/get-verifier-forms-with-status-by-verifier-id/' //{verifier_id}
export const GET_VERIFIER_SESSIONS = '/api/v1/verifier/get-verifyng-session-by-verifier-id/' //{verifier_id}
export const GET_VERIFIER_FORM = '/api/v1/verifier/get-verifier-forms-with-status-by-form-uuid/' //{form_uuid}/
export const DELETE_VERIFIER_FORM = '/api/v1/verifier/delete-form-by-uuid/' //  form-uuid
export const DEACTIVATE_VERIFIER_FORM = '/api/v1/verifier/deactivate-form-by-uuid/' //  form-uuid
export const ACTIVATE_VERIFIER_FORM = '/api/v1/verifier/activate-form-by-uuid/' //  form-uuid
export const GET_VERIFIER_DASHBOARD = '/api/v1/verifier/get-verifier-dashboard/' //  verifier id
export const GET_FORM_SHARE_LINK = '/api/v1/verifier/generate-verifier-qr-code/'
// export const GET_HOLDER_DATA = '/api/v1/verifier/get-verification-data/' //+form_uuid+ veriier id
export const GET_HOLDER_DATA = 'api/v1/verifier/get-verification-details/' //+ holder_uuid
export const VERIFIER_SEARCH = "api/v1/verifier/verifier-search"
export const HOLDER_CONSENT = "api/v1/verifier/request-holder-consent"
export const REQUEST_SENT = ""
export const GET_VERIFIER_MASTER_DOCUMENTS = "api/v1/verifier/get-master-documents"
// verifier Request Verifications
export const GET_ACTIVE_FORMS = '/api/v1/verifier/get-active-forms/' //{verifier_id}
export const GET_DRAFT_FORM_RECIEPIENT = '/api/v1/verifier/get-verification-request-notifications/pending/' //{form_id}
export const SET_DRAFT_FORM_RECIEPIENT = '/api/v1/verifier/save-verification-request-notification'
export const DELETE_DRAFT_FORM_RECIEPIENT = '/api/v1/verifier/delete-verification-request-notification/' //{recipient_detail_id}
export const SEND_REQUEST_VERIFICATION = '/api/v1/verifier/send-verification-request-notification'
export const GET_ALL_VERIFICATION_REQ = '/api/v1/verifier/get-all-verification-request/' //{verifier_id}
export const GET_HOLDER_SHARED_DATA = '/api/v1/verifier/get-holder-shared-data/' //{shared_data_id}
export const UPLOAD_BULK_RECIEPIENTS = '/api/v1/verifier/upload-bulk-verification-request-by-doc-field'
export const GET_GSTIN_DETAILS="/api/v1/user/get-gstin-details/"
export const GET_PAN_STATUS="/api/v1/user/check-pan-status/"

// Document
export const GET_MASTER_DOCUMENTS = "api/v1/issuer/get-all-master-documents"
export const REGISTER_DOCUMENT = "api/v1/issuer/register-document"
export const REMOVE_DOCUMENT = "api/v1/issuer/delete-document/"//+document_id
export const GET_DOCUMENT = "api/v1/issuer/get-document-by-id/"//+document_id
export const GET_DEFAULT_FIELDS = "api/v1/verifier/get-default-fields_by_doc_id/" //{document_id}
export const UPDATE_DOCUMENT_STATUS = "api/v1/issuer/update-document-status/"//+document_id
export const SET_DOCUMENT_ACTIVE = "api/v1/issuer/set-document-status-active/" // {document_id}
export const GET_ALL_TAGS = "api/v1/issuer/get-all-doc-fields"
export const SUBMIT_TAGS = "api/v1/issuer/registered-document-doc-fields"
export const TAGS_BY_ISSUER = "api/v1/issuer/get-document-doc-fields-by-id/"//+Issuer_id
export const VALIDATE_DOCUMENT = "api/v1/issuer/validate-document-template"
export const SUBMIT_DOCUMENT = "api/v1/issuer/add-document-template"
export const PREVIEW_DOCUMENT = "api/v1/issuer/review-document/"//+document_id
export const GET_DOCUMENT_BY_ID = "api/v1/issuer/get-document-by-id/"//+document_id
export const GET_DOCUMENT_FORM_FIELDS = 'api/v1/issuer/get-form-data-for-document-id/' //  + document_id
export const GET_DOCUMENT_LAYOUT = 'api/v1/issuer/get-document-layout/' //  + document_id
export const UPLOAD_BULK_CSV = 'api/v1/issuer/upload-csv'
export const INSERT_ISSUER_DOCUMENT = 'api/v1/issuer/insert-issued-data'
export const GET_ISSUED_DATA_COUNT = 'api/v1/issuer/get-issued-data-count' //issuer_id
export const GET_DOCUMENT_DRAFT_BY_ID = 'api/v1/issuer/get-issued-data-by-document-id-and-issuer-id/' // +issuer_id + id
export const UPDATE_DOCUMENT_DATA = 'api/v1/issuer/update-issued-data'
export const DOCUMENT_PREVIEW = "api/v1/issuer/review-document-with-data/" //+issued_uuid
export const DELETE_DOCUMENT_DATA = 'api/v1/issuer/delete-issued-data/' //Issued_uuid
export const PUBLISH_DOCUMENT_BY_UUID = 'api/v1/issuer/set-issued-uuids-published'
export const PUBLISH_ALL="/api/v1/issuer/publish-all/"
export const REVOKE_DOCUMENT = 'api/v1/issuer/set-issued-data-revoked/' //Issued_uuid
export const GLOBAL_NAME_TEMPLATE = "/api/v1/issuer/predefined-name-enter"
export const PUBLISH_VERIFIER_REQUEST_DOCUMENT = "/api/v1/issuer/publish-verifier-requested-document" //issued_document_id + verifier_request_id
export const GET_ISSUER_ISSUE_DATA_DETAILS="/api/v1/issuer/get-issuer-issue-data-details/" // +issue_uuid/api/v1/issuer/recent
export const ISSUERS_RECENT="/api/v1/issuer/recent"
export const CONVERT_DOCUMENT_BACKGROUND="/api/v1/issuer/convert-document-background"
// DOCUMENT API
export const GET_SUPPORTING_DOCS = '/api/v1/issuer/get-supporting-document-per-doc-field/'//issued_document_id
export const ADD_SUPPORTING_DOCS = '/api/v1/issuer/set-supporting-document-per-doc-field/'//issued_document_id

//Document Layout
export const GET_LAYOUT = "api/v1/issuer/get-document-layout-by-id/" //+document_id
export const UPDATE_DOCUMENT_NAME = "api/v1/issuer/update-document-name"
export const GET_PDF = "api/v1/issuer/generate-pdf/" //+document_id
export const SET_LAYOUT = "/api/v1/issuer/add-document-layout"
export const SET_AND_ACTIVATE_LAYOUT = "/api/v1/issuer/add-document-layout-activate"
export const DELETE_PAGE = "/api/v1/issuer/delete-page-layout/"//+ document_id/page_number

//Help & Support
export const GET_SUBJECT = "/api/v1/notification/get-subject/" //+ role_type
export const CONTACT_US = "/api/v1/notification/contact-us"
// change request flow
export const GET_DISCREPANCY_BY_TICKET_FOR_ISSUER = "/api/v1/issuer/get-discrepancy-by-ticket-for-issuer/" //{ticket_id}
export const ACCEPT_DISCREPANCY_TICKET_BY_ISSUER = "/api/v1/issuer/accept-discrepancy-ticket-by-issuer/"//{ticketID}
export const REJECT_DISCREPANCY_TICKET_BY_ISSUER = "/api/v1/issuer/reject-discrepancy-ticket-by-issuer/" //{ticketID}
export const REISSUE_NEW_DOCUMENT_TICKET_ID = "/api/v1/issuer/reissue-new-document-ticket-id/"//{ticketID}


//pre defined API
export const GET_TEMPLATE_DETAILS = '/api/v1/issuer/get-document-template-details/' ///{type}/{id}
export const COPY_DOCUMENT_TEMPLATE = '/api/v1/issuer/copy-to-document' //{{action}}/{doc_id}/{issuer_id}'
export const GET_ALL_PREDEFINED_TEMPLATES = '/api/v1/issuer/get-all-pre-defined-templates'
export const COPY_TO_MASTER_DOCUMENT = "/api/v1/issuer/copy-to-master-template/"//{document_id}

//packages API
export const GET_ALL_PACKAGES = '/api/v1/verifier/get-all-pre-defined-forms'
export const COPY_PACKAGE_TO_USER = '/api/v1/verifier/copy-to-user-defined-forms'
export const GET_FORM_DETAILS = '/api/v1/verifier/get-verifier-form-details-pp-or-custom/' //{form_id}/{form_type}
export const COPY_TO_MASTER_FORMS = '/api/v1/verifier/copy-to-pre-defined-forms/' //{form_id}
export const DEACTIVATE_MASTER_FORMS = '/api/v1/verifier/update-master-form-status/' //{form_uuid}/{template_id}/{status}

// Qr verifier API
export const GET_QR_SHARED_DATA = "/api/v1/verifier/get-qr-shared-data/"
export const VERIFY_FACE = "/api/v1/verifier/verify-face"
export const VALIDATE_SECURE_QR = "/api/v1/verifier/validate-secure-qr"

// Employment API
export const GET_EMP_DOCUMENTS = "/api/v1/verifier/get-employment-documents"
export const EMP_REQUEST_TO_ISSUER = "/api/v1/verifier/add-request-to-cart"
export const GET_VERIFIER_REQUEST = "/api/v1/issuer/get-all-request-via-issuer-id/" // {issuer_id}
export const GET_ALL_VERIFIER_REQUESTS_BY_VERIFIER_ID = "/api/v1/verifier/get-all-verifier-requests-via-verifier-id/" //{verifier_id}
export const GET_COMPANY_LIST = "api/v1/user/get-company-list" //?name=
export const UPLOAD_LOA="/api/v1/verifier/upload-loa"
export const GET_FORM_FIELDS="/api/v1/verifier/get-form-fields"

export const SEARCH_EMP_RECORDS="/api/v1/verifier/search-records"
export const GET_TEMPLATE_FIELDS_FOR_PREFILL="api/v1/verifier/get-template-fields-for-prefill"
//cart API
export const ADD_TO_CART = "/api/v1/verifier/add-request-to-cart"
export const REMOVE_FROM_CART = "api/v1/payment/remove-cart-item"
export const GET_CART_DETAILS = "api/v1/payment/get-cart-details/" //{User_id}
export const CHECKOUT_CART = ""
export const PAYMENT_VIA_WALLET = "/api/v1/payment/pay-via-wallet"
export const WALLET_DETAILS = "/get-wallet-details" //{user_id}
export const ADD_MONEY = "api/v1/payment/add-money-to-wallet"
export const VERIFY_WALLET = "api/v1/payment/verify-wallet-recharge-payment"
export const EMPTY_CART="/api/v1/payment/empty-cart"
//Appeal API

export const GET_APPEAL_METADATA_VERIFIER="/api/v1/verifier/get-appeal-metadata/"

export const CREATE_APPEAL="/api/v1/verifier/create-appeal/"
export const GET_APPEALS="/api/v1/issuer/get-appeals"
export const GET_APPEAL_METADATA_ISSUER="/api/v1/issuer/get-appeal-metadata/"
export const SET_APPEAL_STATUS="/api/v1/issuer/set-appeal-status"
export const SEND_FOLLOWUP_EMAILS="/api/v1/issuer/send-follow-up-emails"
export const GET_WA_APPEAL_METADATA="/api/v1/wa/get-appeal-metadata/"
export const CREATE_WA_APPEAL="/api/v1/wa/create-wa-appeal"
export const GET_WA_REQUEST_FIELDS="/api/v1/wa/get-wa-request-fields/"
export const CREATE_WA_REQUEST="/api/v1/wa/create-wa-request"
//Super Admin API
export const GLOBAL_REQUESTS="/api/v1/verifier/verification-requests"
export const EXPORT_REQUESTS="/api/v1/verifier/export-requests"
export const GLOBAL_PAYMENTS="/api/v1/payment/payment-orders"
export const REFUND_TRANSACTION="/api/v1/payment/refund-transaction"
export const GET_ALL_COMPANIES="/api/v1/user/get-all-user-companies"
export const DASHBOARD_METRICS="/api/v1/issuer/dashboard-metrics"

export const ATTRATION_INSIGHTS="/api/v1/issuer/attrition-insights"
export const LAST_PUBLISHED_RECORD_BY_ISSUER="/api/v1/issuer/last-published-records-by-issuer"
export const GET_CREDIT_DEBIT_REASONS="/api/v1/payment/get-credit-debit-reasons"
export const GENERATE_CREDIT_NOTE="/api/v1/payment/generate-credit-note"
export const UPDATE_STATUS="api/v1/issuer/update-verification-request-status/"
export const SEND_WELCOME_EMAIL="/api/v1/user/send-welcome-email"
export const VIEW_LOA="/api/v1/verifier/view-loa/"
export const RESEND_VERIFIER_EMAIL="/api/v1/verifier/resend-verifier-email"
export const EXPORT_PAYMENT_ORDERS="/api/v1/payment/export-payment-orders"
export const EXPORT_ISSUER_DOCUMENT_DATA="/api/v1/issuer/export-issuer-document-data"
export const CSV_LOGS_BY_ISSUER="/api/v1/issuer/csv-logs-by-issuer"
export const GET_S3_SIGNED_URL="/api/v1/verifier/get-s3-signed-url"
// AuthNumber Rewards
export const GET_OFFERS_VIA_PACKAGE_TYPE="/api/v1/affiliate/get-offers-via-package-type/" //{package_type}
export const TRACK_OFFER_CLICK="/api/v1/affiliate/track-offer-click"
export const TRACK_SCROLL="/api/v1/affiliate/track-scroll"
export const UPDATE_GSTIN="/api/v1/user/update-gstin"
export const CONTINUE_AS_B2C="api/v1/verifier/continue-as-b2c"
export const GENERATE_ARS__INVOICE__PAYLOAD="/api/v1/verifier/generate-ars-invoice-payload" // {verfier_id}/{transaction_id}
// Rating Platform
export const SET_USER_RATING_COMMENT="/api/v1/user/set-user-rating-comment"
//User Management
export const UPDATE_USER_ROLE="/api/v1/user/update-user-role"
//Credit
export const GET_WALLET_DETAILS="/api/v1/payment/get-wallet-details/"
export const UPDATE_ISSUER_WALLET_STATUS="/api/v1/issuer/update-wallet-status"
export const UPDATE_ISSUER_PER_SEARCH_CREDIT="/api/v1/issuer/update-per-search-credit"
export const ISSUER_ADJUST_CREDITS="/api/v1/issuer/adjust-issuer-credits"
export const EXPORT_TRANSACTION_HISTORY="api/v1/payment/export-transaction-history/"
//Central Wallet
export const CENTRAL_WALLET_VERIFY_TOKEN="api/v1/central-wallet/verify-token"
export const CENTRAL_WALLET_VERIFY_RECHARGE="api/v1/central-wallet/verify-wallet-recharge"

//GSTIN
export const ADD_GSTIN="/api/v1/user/add-gstin"
export const GET_USER_GSTIN="/api/v1/user/get-user-gstins/" //user_id
export const SET_DEFAULT_GSTIN="/api/v1/user/set-default-gstin"

export const GENERATE_ONE_TIME_PDF_LINK="api/v1/verifier/generate-one-time-pdf-link/"
export const GET_CONFIG_DETAILS="/api/v1/user/get-config-details"
//Notification
export const MARK_NOTIFICATION_VIEWED="/api/v1/notification/mark-notification-viewed"
export const USER_TYPES = {
    'Issuer': 1,
    'Verifier': 2
}

export const NIDLIST = [2, 3, 4, 5, 6, 7]

export const localDataKeys = {
    FILE_DRAFT: 'fd',
    SAVED: 's',
    DOCUMENT_DRAFT: 'dd',
    TAGS_DRAFT: 'td',
    LAST_SAVE: 'ls'
}
